<!--
    Template
-->

<template>
    <div>
        <canvas ref="canvas" />
    </div>
</template>



<!--
    Scripts
-->

<script>


    // imports

    import {Chart, scaleLabels, stripedGrid} from '@/common/modules/chart'
    import {price} from '@/common/helpers/parse'


    // colors

    const style =  getComputedStyle(document.documentElement);
    const clBlue = style.getPropertyValue('--cl-blue') || '#0081cc';
    const clOrange = style.getPropertyValue('--cl-orange') || '#f39800';
    const clWhite = style.getPropertyValue('--cl-white') || '#ffffff';
    const clBlack = style.getPropertyValue('--cl-black') || '#222222';
    const clGray = style.getPropertyValue('--cl-gray') || '#d6dbdf';
    const clWhiteDark = style.getPropertyValue('--cl-white-dark') || '#F8FAFB';


    // config

    const config = {
        type: 'line',
        plugins: [
            scaleLabels,
            stripedGrid
        ],
        data: {
            labels: [],
            datasets: [{
                fill: false,
                data: [],
                yAxisID: 'price',
                borderColor: clBlue,
                pointBackgroundColor: clBlue,
                pointRadius: 4,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: clBlue,
            }, {
                fill: false,
                data: [],
                yAxisID: 'sqm',
                borderColor: clOrange,
                pointBackgroundColor: clOrange,
                pointRadius: 4,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: clOrange,
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        display: false
                    }
                }],
                yAxes: [{
                    position: 'left',
                    id: 'price',
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        callback: v => price(v)
                    }
                }, {
                    position: 'right',
                    id: 'sqm',
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        callback: v => price(v)
                    }
                }]
            },
            tooltips: {
                position: 'average',
                mode: 'index',
                intersect: false,
                backgroundColor: clWhite,
                titleFontColor: clBlack,
                bodyFontColor: clBlack,
                borderWidth: 1,
                borderColor: clGray,
                caretSize: 0,
                xPadding: 10,
                yPadding: 10,
                callbacks: {
                    title: (array) => array[0].xLabel + '年',
                    label: ({yLabel}) => price(yLabel)
                }
            },
            plugins: {
                axesLabels: {
                    labels: [{
                        fontStyle: 'bold',
                        fontColor: clBlack,
                        yAxisID: 'price',
                        value: ['成約価格', '(円)']
                    }, {
                        fontStyle: 'bold',
                        fontColor: clBlack,
                        yAxisID: 'sqm',
                        value: ['単価', '(件)']
                    }]
                },
                stripedGrid: {
                    yAxisID: 'price',
                    backgroundColor: clWhiteDark
                }
            }
        }
    };


    // exports

    export default {

        filters: {
            price
        },

        props: [
            'data'
        ],

        methods: {

            update () {
                if (!this.data) return;
                this.chart.data.labels = this.data.chartLabels;
                this.chart.data.datasets[0].data = this.data.chartValuesPrice;
                this.chart.data.datasets[1].data = this.data.chartValuesSqm.map(value => value * this.tsubo);
                this.chart.update();
            }

        },

        watch: {

            data () {
                this.chart && this.update();
            }

        },

        mounted () {
            const ctx = this.$refs.canvas.getContext('2d');
            this.chart = new Chart(ctx, config);
            this.update();
        }

    }

</script>

